import CapricornCreateCsvHtml     from '../capricorn/capricorn.create-csv.html';
import DashboardHomeActionsHtml   from './templates/dashboard.home.actions.html';
import DashboardHomeHtml          from './templates/dashboard.home.html';
import DashboardSalesWidgetsHtml  from './templates/dashboard.sales-widgets.html';
import DealershipTransactionsHtml from '../dealership/dealership.transactions.html';

export function DashboardCtrl (
  $uibModal,
  $q,
  $rootScope,
  $scope,
  $state,
  $translate,
  $window,
  acceptedQuotes,
  advertisementUrl,
  API,
  assemblyPaymentsApi,
  bookingRequests,
  businessIntelligenceDashboards,
  companyApi,
  confirm,
  Dashboard,
  dealershipWidgetStats,
  inspectionWidgetStats,
  integrations,
  jobs,
  jobsApi,
  mechanics,
  messages,
  notifications,
  sessionObjAPI,
  settings,
  SUBSCRIPTIONKEYS,
  transactions,
  tyres,
  vehicleRegistrationApi,
  vehicleRegistrationLookups,
  widgetStats,
  workshopAPI
) {
  $scope.Dashboard = new Dashboard(settings, businessIntelligenceDashboards);

  $scope.acceptedQuotes                    = acceptedQuotes;
  $scope.activity                          = $scope.Dashboard.activity;
  $scope.advertisementUrl                  = advertisementUrl + '?decache=' + Math.random();
  $scope.bookingRequests                   = bookingRequests || 0;
  $scope.dashboardHomeActionsTemplateUrl   = DashboardHomeActionsHtml;
  $scope.dashboardHomeTemplateUrl          = DashboardHomeHtml;
  $scope.dashboardSalesWidgetsTemplateUrl  = DashboardSalesWidgetsHtml;
  $scope.dealershipTransactionsTemplateUrl = DealershipTransactionsHtml;
  $scope.dealershipWidgetStats             = dealershipWidgetStats;
  $scope.inspectionWidgetStats             = inspectionWidgetStats;
  $scope.integrations                      = integrations;
  $scope.jobs                              = jobs;
  $scope.loaded                            = true;
  $scope.mechanics                         = $scope.Dashboard.configureMechanics(mechanics);
  $scope.month                             = new Date().getMonth() + 1;
  $scope.notifications                     = notifications;
  $scope.session                           = sessionObjAPI.base();
  $scope.settings                          = settings;
  $scope.terminal                          = assemblyPaymentsApi.getTerminal();
  $scope.transactions                      = transactions;
  $scope.tyres                             = tyres;
  $scope.vehicleRegistrationLookups        = vehicleRegistrationLookups;
  $scope.widgetStats                       = widgetStats;

  $scope.Company = companyApi;

  $scope.printSettlement = function(receipt_id) {
    var settlement = `${API.url}/reports/jasper_eftpos_receipt/merchant/${receipt_id}.pdf`;

    $window.open(settlement, '_blank');

    return $q.when(receipt_id);
  };

  $scope.buySMS = function () {
    $scope.Company.buySms()
    .then(() => {
      $state.reload();
    });
  };

  $scope.startJobsForDate = function() {
    jobsApi.startForDate();
  };

  $scope.printJobsForDate = function () {
    jobsApi.printForDate();
  };

  $scope.startAndPrintJobsForDate = function () {
    jobsApi.startAndPrintForDate();
  };

  $scope.settleEftpos = function() {
    if ($scope.terminal) {
      assemblyPaymentsApi.spiApi.InitiateSettleTx($scope.terminal.ap_pos_id);
    }
    else {
      messages.show($translate.instant('JS_SPACE.MESSAGES.NO_EFTPOS_FOUND'), 'error');
    };
  };

  $scope.purchaseVehicleRegistrationLookupRequests = function () {
    if ($rootScope.Company.hasIntegration('vehicle-registrations')) {
      return vehicleRegistrationApi.purchaseRequests()
      .then(() => $state.reload());
    }

    $state.go('app.vehicle-registration-settings');
  };

  $scope.getBlog = function () {
    workshopAPI.get('/dashboard/get_blog').then(function (blog) {
      $scope.blog = blog;
    });
  };

  $scope.getReport = function (request) {
    $scope.Dashboard[request]($scope.report).then(function (report) {
      $scope.report = report;
    }, function (err) {
      messages.error(err);
    });
  };

  $scope.getJasperReport = function (timespan) {
    $scope.Dashboard.getJasperReport(timespan);
  };

  $scope.subscriptionUpgrade = function() {
    return $window.location.href = '#/subscription_type_upgrade';
  };

  $scope.annualSubscription = function () {
    $scope.Company.annualSubscription().then(function () {
      messages.show($translate.instant('COMPANY_SPACE.CHARGIFY.ANNUAL_SUCCESSFUL_SUBSCRIPTION'), 'success');
      $state.reload();
    }, function (err) {
      messages.error(err);
    });
  };

  $scope.handleActivityTabSelect = function () {
    $rootScope.$broadcast('resizeGrid');
  };

  $scope.hideSeries = function (selectedItem) {
    $scope.report = $scope.Dashboard.hideReportSeries($scope.report, selectedItem);
  };

  $scope.subscribeToWorkshop = function () {
    confirm.subscribe($translate.instant('JS_SPACE.CONFIRM.SUBSCRIBE_TO_WORKSHOP_SOFTWARE'), { routes: SUBSCRIPTIONKEYS.workshop.routes, link: SUBSCRIPTIONKEYS.workshop.link })
      .then(function () {
        messages.show($translate.instant('JS_SPACE.MESSAGES.SUBSCRIBED_TO_WORKSHOP'), 'success');
      }, function (err) {
        messages.error(err);
      });
  };

  $scope.toggleChart = function () {
    $scope.report.type = $scope.Dashboard.toggleChart($scope.report.type);
  };

  $scope.createCapricornCsv = function () {
    $uibModal.open({
      templateUrl: CapricornCreateCsvHtml,
      controller : 'CreateCapricornCsvCtrl',
      resolve    : {
        integrations () {
          return $scope.integrations;
        }
      }
    }).result;
  };

  $scope.viewBookingRequests = function () {
    $state.go('app.bookings.requests');
  };

  ($scope.Dashboard.fullDashboardPrivileges() && settings.has_workshop) ? $scope.getReport('getSalesReport') : null;

  // moved this call from resolving into the
  // controller to avoid delaying the page
  // from loading for a long time.
  $scope.getBlog();
}